export const APPOINTMENT_BOOKING_API_BASE_URL =
  'https://widget-data.service.elfsight.com/api';

// export const APPOINTMENT_BOOKING_API_BASE_URL_STAGE =
//   'https://widget-data-stage.elfsight.dev/api';
